import { render, staticRenderFns } from "./MenuOptionsWidget.vue?vue&type=template&id=4d04cbac&"
import script from "./MenuOptionsWidget.vue?vue&type=script&lang=js&"
export * from "./MenuOptionsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports